import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { makeStyles } from '@material-ui/core';
import MuiMenuItem from '@material-ui/core/MenuItem';

import Box from '../../Styled/Box';

const Wrapper = styled(Box)(({ theme }) => {
  const { tag, ...typography } = theme.typography.helper;

  return ({
    ...typography,
    width: '100%',
    color: theme.colors.coldgrey700,
    fontFamily: theme.fonts.regular,
  });
});

const useStyles = (theme, styles) => makeStyles(() => {
  const { root, selected, ...rest } = (styles || {});

  return ({
    root: {
      ...root,
    },
    selected: {
      background: theme.colors.coldgrey200,
      ...selected,
    },
    ...rest,
  });
});

const MenuItem = ({
  theme,
  children,
  styles,
  ...props
}) => {
  const classes = useStyles(theme, styles)();

  return (
    <MuiMenuItem classes={classes} {...props}>
      <Wrapper>
        {children}
      </Wrapper>
    </MuiMenuItem>
  );
};

MenuItem.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  styles: PropTypes.object,
};

MenuItem.defaultProps = {
  styles: {},
};

export default withTheme(MenuItem);
